(function($) {
	'use strict';

	$.widget('msv.dateRange', {

		options: {
			mediumAndUp: window.matchMedia('(min-width: 960px)')
		},

		_init: function() {

			this._events()
			this._showDates()
		},

		_events: function() {
			var self = this;

			//input daterange
			this.element.daterangepicker({
				autoUpdateInput: false,
				startDate: moment(),
				minDate: moment(),
				autoApply: true,
				opens: self.options.mediumAndUp.matches ? 'right' : 'center',
				locale: {
					'format': 'MM/DD/YYYY',
					'daysOfWeek': self.element.parent().data('days'),
					"monthNames": self.element.parent().data('months')
				}
			});
		},

		_showDates: function() {
			this.element.on('apply.daterangepicker', function(_, picker) {
				$(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
			});
		}
	});

})(jQuery);